// extracted by mini-css-extract-plugin
module.exports = {"searchArea":"styles_searchArea__1uePV","search":"styles_search__RxEAk"};